import axios from "axios";
import { Auth } from "aws-amplify";

export function getDefaultProps(name) {
  switch (name) {
    case "fileUrl": // 파일서버 URL
      return process.env.REACT_APP_R_FILE; // 서버
  }
}

const baseClient = axios.create({
  baseURL: process.env.REACT_APP_R_BASECLIEN, // 서버
  timeout: 30 * 1000,
  headers: {
    Accept: "application/json",
    useQuerystring: true,
  },
});

/** IdToken 만료 전 RefreshToken으로 세션 갱신 후 JWT 반환 */
export async function refreshIdToken() {
  // Amplify currentSession(): Id/Access Token 만료 시 RefreshToken으로 자동 재발급
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  sessionStorage.setItem("corners-token", idToken);
  return idToken;
}

baseClient.interceptors.request.use(async function (config) {
  try {
    // 요청마다 최신 IdToken을 헤더에 설정 (만료 시 RefreshToken으로 갱신)
    config.headers["corners-token"] = await refreshIdToken();
  } catch (e) {
    const cached = sessionStorage.getItem("corners-token");
    if (cached) {
      config.headers["corners-token"] = cached;
    }
  }
  return config;
});

baseClient.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export default baseClient;

export async function baseApiCheck(isAuthCheck = true) {
  const signOut = async () => {
    try {
      await Auth.signOut();
      window.location.href = "/";
      sessionStorage.clear();
      localStorage.clear();
    } catch (error) {}
  };

  try {
    // RefreshToken으로 IdToken 갱신 (만료 전이면 기존 세션 유지)
    await refreshIdToken();

    const loginUser = await Auth.currentAuthenticatedUser();

    loginUser.info = {
      userId: sessionStorage.getItem("userId"),
      authCd: sessionStorage.getItem("authCd"),
      email: sessionStorage.getItem("email"),
      userName: sessionStorage.getItem("userName"),
      tel1: sessionStorage.getItem("tel1"),
      loginId: sessionStorage.getItem("loginId"),
      siteId: sessionStorage.getItem("siteId"),
      compId: sessionStorage.getItem("compId"),
      svcCd: sessionStorage.getItem("svcCd"),
    };

    return loginUser;
  } catch (error) {
    // RefreshToken까지 만료되었거나 세션이 없으면 로그아웃
    if (isAuthCheck) {
      signOut().then();
    }
    return null;
  }
}

// IdToken 기본 만료(1시간)보다 짧게 주기적으로 갱신해 화면 유지
const TOKEN_REFRESH_INTERVAL_MS = 45 * 60 * 1000;
let tokenRefreshTimerId = null;

export function startTokenRefreshScheduler() {
  if (tokenRefreshTimerId != null) {
    return;
  }

  tokenRefreshTimerId = setInterval(async () => {
    try {
      if (!sessionStorage.getItem("corners-token")) {
        return;
      }
      await refreshIdToken();
    } catch (e) {
      // 갱신 실패(RefreshToken 만료 등)는 다음 API 호출 시 baseApiCheck에서 로그아웃 처리
    }
  }, TOKEN_REFRESH_INTERVAL_MS);
}
